import React from 'react';
import AutoEmbedPlugin from '../plugins/AutoEmbedPlugin';
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin';
import { CharacterLimitPlugin } from '@lexical/react/LexicalCharacterLimitPlugin';
import { ListPlugin } from '@lexical/react/LexicalListPlugin';
import LinkPlugin from '../plugins/LinkPlugin';
import AutoLinkPlugin from '../plugins/AutoLinkPlugin';

import { AutoFocusPlugin } from '@lexical/react/LexicalAutoFocusPlugin';
import DraggableBlockPlugin from '../plugins/DraggableBlockPlugin';
import CodeActionMenuPlugin from '../plugins/CodeActionMenuPlugin';
import FloatingLinkEditorPlugin from '../plugins/FloatingLinkEditorPlugin';
import FloatingTextFormatToolbarPlugin from '../plugins/FloatingTextFormatToolbarPlugin';
import MediaPlugin from '../plugins/MediaPlugin';
import { MaxLengthPlugin } from '../plugins/MaxLengthPlugin';
import DragDropPaste from '../plugins/DragDropPastePlugin';
import MarkdownShortcutPlugin from '../plugins/MarkdownShortcutPlugin';
import CodeHighlightPlugin from '../plugins/CodeHighlightPlugin';
import { CheckListPlugin } from '@lexical/react/LexicalCheckListPlugin';
import TwitterPlugin from '../plugins/TwitterPlugin';
import YouTubePlugin from '../plugins/YouTubePlugin';
import ComponentPickerPlugin from '../plugins/ComponentPickerPlugin';
import EmojiPickerPlugin from '../plugins/EmojiPickerPlugin';
import EmojisPlugin from '../plugins/EmojisPlugin';
import { HashtagPlugin } from '@lexical/react/LexicalHashtagPlugin';
import EquationsPlugin from '../plugins/EquationsPlugin';
import ExcalidrawPlugin from '../plugins/ExcalidrawPlugin';
import { TabIndentationPlugin } from '@lexical/react/LexicalTabIndentationPlugin';
import PollPlugin from '../plugins/PollPlugin';
import CollapsiblePlugin from '../plugins/CollapsiblePlugin';
import { HorizontalRulePlugin } from '@lexical/react/LexicalHorizontalRulePlugin';
import { BeautifulMentionsPlugin } from 'lexical-beautiful-mentions';
import { queryMentions } from '../../../apis/users';
import MentionsMenu from '../components/Mentions/MentionsMenu';
import MentionsMenuItem from '../components/Mentions/MentionsItem';

export interface BaseEditorProps {
  historyState?: any;
  maxLength?: number;
  shouldFocus?: boolean;
  isCommentEditor?: boolean;
}

export const BaseEditorPlugins = ({
  historyState,
  maxLength = 50000,
  shouldFocus,
  isCommentEditor
}: BaseEditorProps) => {
  return (
    <>
      <HistoryPlugin externalHistoryState={historyState} />
      {shouldFocus && <AutoFocusPlugin />}
      <MediaPlugin shouldFocus={shouldFocus} isCommentEditor={isCommentEditor} />
      <AutoLinkPlugin />
      <LinkPlugin />
      {/* <CharacterLimitPlugin charset={'UTF-8'} maxLength={500000} /> */}
      <HorizontalRulePlugin />
      <MaxLengthPlugin maxLength={maxLength} />
      <AutoEmbedPlugin />
      <DragDropPaste />
      <MarkdownShortcutPlugin />
      <CodeHighlightPlugin />
      <ListPlugin />
      <CheckListPlugin />
      <TwitterPlugin />
      <YouTubePlugin />
      <ComponentPickerPlugin />
      <EmojiPickerPlugin />
      <EmojisPlugin />
      <HashtagPlugin />
      <EquationsPlugin />
      <ExcalidrawPlugin />
      <TabIndentationPlugin />
      <PollPlugin />
      <CollapsiblePlugin />
      <BeautifulMentionsPlugin
        triggers={['@']}
        onSearch={queryMentions}
        menuComponent={MentionsMenu}
        menuItemComponent={MentionsMenuItem}
      />
    </>
  );
};

export const FloatingPlugins: React.FC<{
  anchorElem: HTMLDivElement;
  isLinkEditMode: boolean;
  setIsLinkEditMode: (isEdit: boolean) => void;
}> = ({ anchorElem, isLinkEditMode, setIsLinkEditMode }) => {
  return (
    <>
      <DraggableBlockPlugin anchorElem={anchorElem} />
      <CodeActionMenuPlugin anchorElem={anchorElem} />
      <FloatingLinkEditorPlugin
        anchorElem={anchorElem}
        isLinkEditMode={isLinkEditMode}
        setIsLinkEditMode={setIsLinkEditMode}
      />
      <FloatingTextFormatToolbarPlugin
        anchorElem={anchorElem}
        setIsLinkEditMode={setIsLinkEditMode}
      />
    </>
  );
};
